export default {
  "s7": {
    "contactus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact Us"])},
    "btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact Us"])},
    "contactustitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stay in touch with us"])},
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please click below to find our contact details."])}
  }
}